import { gql } from '@apollo/client'

export const GET_CHARTS_BY_SPACE_ID_AND_COUNTRY = gql`
  query ($space_id: String!, $countryCode: String!) {
    getChartsBySpaceIdAndCountry(space_id: $space_id, countryCode: $countryCode) {
      chart {
        id
        name
        configuration
        period
        import_limit
        chart
        origin
      }
      data {
        artist
        chart
        configuration
        country_code
        date
        received_date
        origin
        rank
        title
        campaign_id
        product_id
        label_id
      }
    }
  }
`
